import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Search from 'material-ui/svg-icons/action/search'
import css from './search-bar.css'

class SearchBar extends Component {
  static propTypes = {
    handleSearchParams: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    isMessagesTab: PropTypes.bool,
  }

  static defaultProps = {
    placeholder: 'Search by name',
  }

  constructor(props) {
    super(props)
    this.state = {
      searchText: props.value,
    }
  }

  componentDidMount() {
    const { value } = this.props
    this.setInitialState(value)
  }

  onChange = (e) => {
    e.persist()
    this.setState({ searchText: e.target.value })
    this.debounce(() => this.props.onChange(e), 300)
  }

  onSubmit = (e) => {
    e.preventDefault()
  }

  setInitialState = value => this.setState({ searchText: value })

  debounce(funcToDelay, delayByTime) {
    clearTimeout(this.onChangeTimeout)
    this.onChangeTimeout = setTimeout(funcToDelay, delayByTime)
  }

  render() {
    const { placeholder, isMessagesTab } = this.props
    const containerClass = isMessagesTab ? css.messagesContainer : css.container

    return (
      <div className={containerClass}>
        <form onSubmit={this.onSubmit} className={css.form}>
          <input
            placeholder={placeholder}
            value={this.state.searchText}
            onChange={this.onChange}
            className={css.input}
            type="search"
            name="search"
          />
          <button className={css.button} type="submit">
            <Search />
          </button>
        </form>
      </div>
    )
  }
}

export default SearchBar




// WEBPACK FOOTER //
// ./src/components/sitewide/Filter/SearchBar.js